import React from "react";

export function VideoRow({ className = "", src, poster, children, ...props }) {
  return (
    <section className={`video-row ${className}`} {...props}>
      <div className="video-row-media">
        <video
          className="video-row-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster={poster}
        >
          <source src={src} type="video/mp4" />
        </video>
      </div>

      {children && <div className="video-row-overlay">{children}</div>}
    </section>
  );
}
